import { connect } from 'react-redux';

import VerifyEmailForm from './VerifyEmailForm';
import { actionCreators } from '../../../../dux/user';

const mapDispatchToProps = {
  handleSendEmailVerification: actionCreators.sendEmailVerification,
};

export default connect(null, mapDispatchToProps)(VerifyEmailForm);
